import { useCallback } from 'react'
import type { DragSourceMonitor } from 'react-dnd'
import { useDrag } from 'react-dnd'

import type { DND_TYPE, DragItemType } from '../constant'

type Params = {
  type: DND_TYPE
  id: number
}

type DropItem = DragItemType
type Collect = { isDragging: boolean }

export const useBaseDrag = ({ type, id }: Params) => {
  const handleDragCollect = useCallback((monitor: DragSourceMonitor) => {
    return {
      isDragging: monitor.isDragging()
    }
  }, [])

  return useDrag<DragItemType, DropItem, Collect>({
    type,
    item: {
      type,
      id
    },
    collect: handleDragCollect
  })
}
